/**
 * PocketFiler - Portuguese (pt) Translation File
 * Complete translation - all keys from en.js
 */

const pt = {
  "nav.login": "Entrar",
  "nav.signup": "Começar",
  "nav.logout": "Sair",
  "nav.dashboard": "Painel",
  "nav.virtualOffices": "Escritórios Virtuais",
  "nav.clients": "Clientes",
  "nav.deals": "Negócios",
  "nav.documents": "Documentos",
  "nav.messages": "Mensagens",
  "nav.settings": "Configurações",
  "nav.invoices": "Faturas",
  "nav.templates": "Modelos",
  "nav.tasks": "Tarefas",
  "nav.meetings": "Reuniões",
  "nav.analytics": "Análise",
  "landing.badge": "Plataforma de Negócios com IA",
  "landing.hero.title": "Feche negócios importantes em qualquer idioma",
  "landing.hero.titleHighlight": "com IA",
  "landing.hero.subtitle": "PocketFiler ajuda empresas e indivíduos a realizar transações documentais de alta confiança – do comércio global a vendas locais de carros e apólices de seguro – com tradução por IA, fluxos de documentos e Salas de Negócios para cada transação.",
  "landing.hero.cta.start": "Começar Grátis",
  "landing.hero.cta.demo": "Veja como funciona",
  "landing.useCases.title": "Construído para Comércio Global, Serviços Locais e Grandes Negócios Pessoais",
  "landing.useCases.subtitle": "Seja importando produtos do exterior ou vendendo seu carro na cidade, PocketFiler oferece as ferramentas para fechar com confiança.",
  "landing.useCases.globalTrade.title": "Comércio Global e Manufatura",
  "landing.useCases.globalTrade.desc": "Encontre e trabalhe com fornecedores estrangeiros, colete documentos de conformidade e negocie em Salas de Negócios com tradução em tempo real.",
  "landing.useCases.insurance.title": "Seguros, Empréstimos e Serviços Profissionais",
  "landing.useCases.insurance.desc": "Convide clientes para enviar documentos, extratos e formulários em seu idioma, depois acompanhe cada documento e mensagem em Escritórios Virtuais.",
  "landing.useCases.realEstate.title": "Imóveis e Transações de Propriedades",
  "landing.useCases.realEstate.desc": "Guie compradores e inquilinos através de aplicações, divulgações e contratos em vários idiomas, tudo em uma única Sala de Negócios por transação.",
  "landing.useCases.vehicle.title": "Vendas Privadas de Veículos e Ativos",
  "landing.useCases.vehicle.desc": "Use Salas de Negócios e contratos gerados por IA para lidar com documentação de compra e venda de carros, equipamentos e outros itens de alto valor.",
  "landing.audience.title": "Projetado para Indivíduos e Equipes",
  "landing.audience.individuals.title": "Para Indivíduos",
  "landing.audience.individuals.bullet1": "Feche negócios importantes únicos como compra de carros, equipamentos ou itens de alto valor com registros claros.",
  "landing.audience.individuals.bullet2": "Use links simples e seguros para enviar documentos e revisar contratos do seu celular.",
  "landing.audience.individuals.bullet3": "Mantenha todas as mensagens, arquivos e rascunhos de contratos de cada negócio em um só lugar, mesmo após o negócio ser concluído.",
  "landing.audience.teams.title": "Para Empresas e Equipes",
  "landing.audience.teams.bullet1": "Configure Escritórios Virtuais para cada linha de serviço (seguros, imóveis, empréstimos, importações) com checklists personalizados.",
  "landing.audience.teams.bullet2": "Convide clientes em qualquer idioma para enviar documentos, assinar contratos e comunicar nas Salas de Negócios.",
  "landing.audience.teams.bullet3": "Dê à sua equipe um espaço de trabalho compartilhado com linhas do tempo, resumos de IA e histórico completo para cada transação.",
  "landing.howItWorks.title": "Como PocketFiler Funciona para Qualquer Negócio",
  "landing.howItWorks.subtitle": "Quatro recursos poderosos que trabalham juntos para ajudá-lo a fechar negócios mais rápido e com menos atrito.",
  "landing.howItWorks.concierge.title": "Concierge IA",
  "landing.howItWorks.concierge.desc": "Seu assistente de IA aprende sobre seu negócio, configura os Escritórios Virtuais certos e cria checklists de documentos para cada tipo de negócio.",
  "landing.howItWorks.translation.title": "Tradução Automática",
  "landing.howItWorks.translation.desc": "Mensagens e conteúdo chave são traduzidos instantaneamente entre as partes, para que compradores, vendedores e clientes possam se comunicar em seu próprio idioma.",
  "landing.howItWorks.documents.title": "Documentos Inteligentes",
  "landing.howItWorks.documents.desc": "Clientes enviam documentos do celular; IA extrai campos chave, verifica qualidade e sinaliza problemas antes que atrasem o negócio.",
  "landing.howItWorks.dealRooms.title": "Salas de Negócios e Contratos",
  "landing.howItWorks.dealRooms.desc": "Cada negócio recebe uma Sala dedicada com linha do tempo, mensagens, documentos e rascunhos de contratos gerados por IA que você pode revisar e finalizar.",
  "landing.cta.title": "Pronto para fechar seu próximo negócio?",
  "landing.cta.subtitle": "Junte-se a empresas e indivíduos usando PocketFiler para lidar com transações importantes com confiança.",
  "landing.cta.button": "Criar Conta Grátis",
  "landing.footer.tagline": "Negócios importantes simplificados.",
  "language.picker.title": "Escolha seu idioma",
  "language.picker.subtitle": "Mostraremos todas as instruções, mensagens e contratos neste idioma. Outros podem escolher seu próprio idioma; a IA cuidará da tradução para você.",
  "language.picker.continue": "Continuar",
  "language.picker.playSample": "Ouvir exemplo",
  "language.picker.playing": "Reproduzindo...",
  "language.picker.confirmation": "Você selecionou {language}. Mostraremos tudo neste idioma. Outras partes podem escolher seu próprio idioma; PocketFiler traduz mensagens, documentos e contratos para que todos entendam.",
  "language.toast.saved": "Idioma salvo! Para alterá-lo, vá para Configurações no seu perfil.",
  "language.confirm.title": "Confirme seu idioma",
  "language.confirm.subtitle": "Este idioma será usado para toda a interface, mensagens e contratos.",
  "language.confirm.change": "Alterar idioma",
  "language.confirm.continue": "Continuar com",
  "language.confirm.chineseNote": "Nota: Você selecionou chinês simplificado (简体中文). Se preferir chinês tradicional, por favor altere sua seleção.",
  "auth.login.title": "Bem-vindo de volta",
  "auth.login.subtitle": "Entre na sua conta PocketFiler",
  "auth.login.email": "E-mail",
  "auth.login.password": "Senha",
  "auth.login.submit": "Entrar",
  "auth.login.noAccount": "Não tem uma conta?",
  "auth.login.signupLink": "Cadastre-se",
  "auth.login.error": "E-mail ou senha inválidos",
  "auth.signup.title": "Crie sua conta",
  "auth.signup.subtitle": "Comece a fechar negócios em qualquer idioma",
  "auth.signup.name": "Nome Completo",
  "auth.signup.email": "E-mail",
  "auth.signup.password": "Senha",
  "auth.signup.confirmPassword": "Confirmar Senha",
  "auth.signup.companyName": "Nome da Empresa",
  "auth.signup.companyType": "Tipo de Indústria",
  "auth.signup.submit": "Criar Conta",
  "auth.signup.hasAccount": "Já tem uma conta?",
  "auth.signup.loginLink": "Entrar",
  "auth.signup.terms": "Ao se cadastrar, você concorda com nossos Termos de Serviço e Política de Privacidade.",
  "dashboard.title": "Painel",
  "dashboard.welcome": "Bem-vindo de volta, {name}",
  "dashboard.aiSummary.title": "Resumo IA",
  "dashboard.aiSummary.generating": "Gerando resumo...",
  "dashboard.stats.totalDeals": "Total de Negócios",
  "dashboard.stats.activeDeals": "Negócios Ativos",
  "dashboard.stats.totalClients": "Total de Clientes",
  "dashboard.stats.documentsProcessed": "Documentos Processados",
  "dashboard.recentDeals.title": "Negócios Recentes",
  "dashboard.recentDeals.viewAll": "Ver todos",
  "dashboard.recentDeals.empty": "Ainda sem negócios. Crie seu primeiro negócio para começar.",
  "dashboard.recentClients.title": "Clientes Recentes",
  "dashboard.recentClients.viewAll": "Ver todos",
  "dashboard.recentClients.empty": "Ainda sem clientes. Convide seu primeiro cliente para começar.",
  "dashboard.quickActions.title": "Ações Rápidas",
  "dashboard.quickActions.createDeal": "Criar Negócio",
  "dashboard.quickActions.inviteClient": "Convidar Cliente",
  "dashboard.quickActions.createOffice": "Criar Escritório Virtual",
  "offices.title": "Escritórios Virtuais",
  "offices.subtitle": "Organize seu negócio por tipo de serviço",
  "offices.create": "Criar Escritório Virtual",
  "offices.empty.title": "Ainda sem escritórios virtuais",
  "offices.empty.desc": "Crie seu primeiro Escritório Virtual para organizar seus negócios e clientes.",
  "offices.card.clients": "{count} clientes",
  "offices.card.deals": "{count} negócios",
  "offices.card.checklist": "Itens do checklist",
  "offices.checklist": "Checklist de Documentos",
  "offices.noChecklist": "Nenhum documento necessário",
  "offices.dialog.title": "Criar Escritório Virtual",
  "offices.dialog.desc": "Configure um novo espaço de trabalho para um tipo específico de serviço",
  "offices.dialog.name": "Nome do Escritório",
  "offices.dialog.namePlaceholder": "ex: Sinistros de Seguro, Vendas Imobiliárias",
  "offices.dialog.type": "Tipo de Escritório",
  "offices.dialog.description": "Descrição",
  "offices.dialog.descriptionPlaceholder": "Descreva o que este escritório gerencia...",
  "offices.dialog.checklist": "Checklist de Documentos",
  "offices.dialog.checklistHelp": "Checklist gerado por IA para documentos necessários",
  "offices.dialog.addItem": "Adicionar Item",
  "offices.dialog.generateChecklist": "Gerar com IA",
  "offices.dialog.creating": "Criando...",
  "offices.dialog.create": "Criar Escritório",
  "offices.form.name": "Nome do Escritório",
  "offices.form.namePlaceholder": "ex: Serviços de Seguro, Imóveis, etc.",
  "offices.form.description": "Descrição",
  "offices.form.descPlaceholder": "Que tipo de negócios este escritório vai gerenciar?",
  "offices.form.checklistPlaceholder": "Adicionar documento necessário...",
  "offices.ai.title": "Configuração Assistida por IA",
  "offices.ai.desc": "Deixe nosso Concierge IA ajudá-lo a configurar o escritório virtual perfeito fazendo perguntas sobre suas necessidades de negócio.",
  "offices.ai.manual": "Configurar Manualmente",
  "offices.ai.start": "Iniciar Configuração IA",
  "offices.ai.startOnboarding": "Me ajude a configurar meu escritório virtual",
  "offices.ai.suggestion": "Sugestão da IA",
  "offices.ai.acceptSuggestion": "Aceitar e Criar Escritório",
  "offices.ai.inputPlaceholder": "Digite sua resposta...",
  "clients.title": "Clientes",
  "clients.subtitle": "Gerencie seus clientes e convites",
  "clients.invite": "Convidar Cliente",
  "clients.empty.title": "Ainda sem clientes",
  "clients.empty.desc": "Convide seu primeiro cliente para começar.",
  "clients.table.name": "Nome",
  "clients.table.client": "Cliente",
  "clients.table.contact": "Contato",
  "clients.table.office": "Escritório",
  "clients.table.language": "Idioma",
  "clients.table.status": "Status",
  "clients.table.actions": "Ações",
  "clients.status.invited": "Convidado",
  "clients.status.active": "Ativo",
  "clients.status.completed": "Concluído",
  "clients.dialog.title": "Convidar Novo Cliente",
  "clients.dialog.name": "Nome do Cliente",
  "clients.dialog.email": "Endereço de E-mail",
  "clients.dialog.phone": "Número de Telefone",
  "clients.dialog.office": "Escritório Virtual",
  "clients.dialog.language": "Idioma Preferido",
  "clients.dialog.sending": "Enviando convite...",
  "clients.dialog.send": "Enviar Convite",
  "clients.toast.invited": "Convite enviado para {name}",
  "clients.toast.deleted": "Cliente removido",
  "clients.toast.linkCopied": "Link de convite copiado para a área de transferência",
  "clients.invite.step1Title": "Convidar Novo Cliente",
  "clients.invite.step2Title": "Prévia da Mensagem de Convite",
  "clients.invite.step3Title": "Convite Enviado!",
  "clients.invite.step1Desc": "Insira as informações de contato do cliente",
  "clients.invite.step2Desc": "Revise e personalize a mensagem de convite",
  "clients.invite.step3Desc": "Compartilhe o link de convite com seu cliente",
  "clients.invite.nameLabel": "Nome do Cliente",
  "clients.invite.namePlaceholder": "ex: João Silva",
  "clients.invite.contactMethod": "Método de Contato",
  "clients.invite.phone": "Número de Telefone",
  "clients.invite.customNote": "Nota Personalizada",
  "clients.invite.customNotePlaceholder": "Instruções especiais para este cliente...",
  "clients.invite.previewMessage": "Prévia da Mensagem",
  "clients.invite.aiGenerated": "Mensagem de convite gerada por IA",
  "clients.invite.messagePreview": "Prévia da Mensagem",
  "clients.invite.messageEditHint": "Você pode editar esta mensagem antes de enviar",
  "clients.invite.documentsRequested": "Documentos solicitados",
  "clients.invite.regenerate": "Regenerar mensagem",
  "clients.invite.sendInvite": "Enviar Convite",
  "clients.invite.linkCreated": "Link de Convite Criado!",
  "clients.invite.linkCopiedToClipboard": "O link foi copiado para sua área de transferência",
  "clients.invite.shareLink": "Compartilhe este link com seu cliente por e-mail, SMS ou pessoalmente",
  "clients.invite.inviteAnother": "Convidar Outro",
  "clients.invite.success": "Cliente convidado!",
  "clients.invite.linkCopied": "Link de convite copiado!",
  "clients.invite.yourAgent": "Seu agente",
  "clients.invite.defaultOffice": "Nosso Escritório",
  "deals.title": "Negócios",
  "deals.subtitle": "Acompanhe e gerencie suas transações",
  "deals.create": "Criar Negócio",
  "deals.empty.title": "Ainda sem negócios",
  "deals.empty.desc": "Crie seu primeiro negócio para começar.",
  "deals.search": "Buscar negócios...",
  "deals.filter.all": "Todos os Negócios",
  "deals.filter.active": "Ativos",
  "deals.filter.pending": "Pendentes",
  "deals.filter.closed": "Fechados",
  "deals.column.draft": "Rascunho",
  "deals.column.active": "Ativos",
  "deals.column.pending": "Pendentes",
  "deals.column.closed": "Fechados",
  "deals.card.documents": "{count} documentos",
  "deals.card.messages": "{count} mensagens",
  "deals.dialog.title": "Criar Novo Negócio",
  "deals.dialog.dealTitle": "Título do Negócio",
  "deals.dialog.dealTitlePlaceholder": "ex: Compra de Veículo - Honda Civic 2023",
  "deals.dialog.client": "Cliente",
  "deals.dialog.office": "Escritório Virtual",
  "deals.dialog.type": "Tipo de Negócio",
  "deals.dialog.notes": "Notas",
  "deals.dialog.notesPlaceholder": "Adicione notas sobre este negócio...",
  "deals.dialog.creating": "Criando...",
  "deals.dialog.create": "Criar Negócio",
  "dealRoom.back": "Voltar para Negócios",
  "dealRoom.readOnly.title": "Somente Leitura",
  "dealRoom.readOnly.closedMessage": "Este negócio foi fechado. A Sala de Negócios agora é somente leitura para referência e auditoria.",
  "dealRoom.readOnly.cancelledMessage": "Este negócio foi cancelado. A Sala de Negócios agora é somente leitura para referência e auditoria.",
  "dealRoom.tabs.messages": "Mensagens",
  "dealRoom.tabs.documents": "Documentos",
  "dealRoom.tabs.contract": "Contrato",
  "dealRoom.timeline.title": "Linha do Tempo de Atividades",
  "dealRoom.timeline.empty": "Ainda sem atividades",
  "dealRoom.details.title": "Detalhes do Negócio",
  "dealRoom.details.notes": "Notas",
  "dealRoom.details.type": "Tipo",
  "dealRoom.details.documents": "Documentos",
  "dealRoom.details.messages": "Mensagens",
  "dealRoom.aiSummary.title": "Resumo IA",
  "dealRoom.aiSummary.generating": "Gerando resumo...",
  "dealRoom.messages.empty": "Ainda sem mensagens. Inicie a conversa.",
  "dealRoom.messages.placeholder": "Digite uma mensagem...",
  "dealRoom.messages.send": "Enviar",
  "dealRoom.messages.sending": "Enviando...",
  "dealRoom.messages.showOriginal": "Mostrar original",
  "dealRoom.messages.showTranslation": "Mostrar tradução",
  "dealRoom.messages.translatedFrom": "Traduzido de {language}",
  "dealRoom.messages.suggestReply": "Sugerir Resposta",
  "dealRoom.documents.empty": "Ainda sem documentos enviados.",
  "dealRoom.documents.upload": "Enviar Documento",
  "dealRoom.documents.uploading": "Enviando...",
  "dealRoom.documents.analyze": "Analisar",
  "dealRoom.documents.analyzing": "Analisando...",
  "dealRoom.documents.download": "Baixar",
  "dealRoom.documents.delete": "Excluir",
  "dealRoom.documents.pending": "Análise Pendente",
  "dealRoom.documents.analyzed": "Analisado",
  "dealRoom.documents.aiAnalysis": "Análise de Documento por IA",
  "dealRoom.documents.type": "Tipo de Documento",
  "dealRoom.documents.confidence": "Confiança",
  "dealRoom.documents.summary": "Resumo",
  "dealRoom.documents.issues": "Problemas",
  "dealRoom.contract.empty.title": "Nenhum contrato gerado ainda",
  "dealRoom.contract.empty.desc": "Gere um rascunho de contrato por IA para este negócio.",
  "dealRoom.contract.generate": "Gerar Rascunho de Contrato",
  "dealRoom.contract.regenerate": "Regenerar Contrato",
  "dealRoom.contract.generating": "Gerando...",
  "dealRoom.contract.aiLabel": "Rascunho de contrato gerado por IA",
  "dealRoom.contract.language": "Idioma",
  "dealRoom.contract.copy": "Copiar",
  "dealRoom.contract.copied": "Copiado para a área de transferência",
  "dealRoom.contract.type": "Tipo de Contrato",
  "dealRoom.contract.generated": "Gerado",
  "dealRoom.contract.languages": "Idiomas",
  "dealRoom.contract.status": "Status",
  "dealRoom.contract.notice": "Análise de documento por IA: Uma ou mais cláusulas não têm equivalente direto entre os idiomas selecionados. Usamos linguagem descritiva. Por favor, revise estas seções cuidadosamente e confirme com a outra parte se necessário.",
  "dealRoom.contract.dialog.title": "Gerar Rascunho de Contrato",
  "dealRoom.contract.dialog.desc": "A IA gerará um contrato bilíngue baseado nos detalhes do negócio.",
  "dealRoom.contract.dialog.disclaimer": "Este é um rascunho gerado por IA para fins de revisão. Tenha um profissional jurídico revisando antes de assinar.",
  "dealRoom.contract.dialog.type": "Tipo de Contrato",
  "dealRoom.contract.dialog.languages": "Idiomas",
  "dealRoom.contract.dialog.languagesHelp": "Selecione dois idiomas para seu contrato bilíngue. Todos os idiomas Tier 1 são totalmente suportados.",
  "dealRoom.contract.dialog.primary": "Primário",
  "dealRoom.contract.dialog.secondary": "Secundário",
  "dealRoom.contract.dialog.terms": "Termos Especiais",
  "dealRoom.contract.dialog.termsPlaceholder": "Adicione termos ou condições especiais...",
  "dealRoom.contract.dialog.generate": "Gerar Contrato",
  "dealRoom.contract.dialog.generating": "Gerando...",
  "dealRoom.status.change": "Alterar Status",
  "dealRoom.status.dialog.title": "Alterar Status do Negócio",
  "dealRoom.status.dialog.from": "De",
  "dealRoom.status.dialog.to": "Para",
  "dealRoom.status.dialog.reason": "Motivo (opcional)",
  "dealRoom.status.dialog.reasonPlaceholder": "Por que você está alterando o status?",
  "dealRoom.status.dialog.confirm": "Confirmar Alteração",
  "dealRoom.status.dialog.changing": "Alterando...",
  "dealRoom.status.toast.changed": "Status alterado para {status}",
  "dealRoom.upgrade.title": "Fazer Upgrade para Business",
  "dealRoom.upgrade.desc": "Geração de contratos requer um plano Business.",
  "dealRoom.upgrade.features": "Com Business, você obtém:",
  "dealRoom.upgrade.feature1": "Rascunhos de contratos gerados por IA",
  "dealRoom.upgrade.feature2": "Análise avançada de documentos",
  "dealRoom.upgrade.feature3": "Suporte prioritário",
  "dealRoom.upgrade.button": "Fazer Upgrade Agora",
  "settings.title": "Configurações",
  "settings.subtitle": "Gerencie sua conta e organização",
  "settings.tabs.profile": "Perfil",
  "settings.tabs.organization": "Organização",
  "settings.profile.title": "Configurações do Perfil",
  "settings.profile.subtitle": "Gerencie suas informações pessoais",
  "settings.profile.name": "Nome Completo",
  "settings.profile.email": "E-mail",
  "settings.profile.emailNote": "E-mail não pode ser alterado",
  "settings.profile.language": "Idioma Preferido",
  "settings.profile.languageHelp": "Toda a interface, mensagens e contratos serão exibidos neste idioma.",
  "settings.profile.save": "Salvar Alterações",
  "settings.profile.saving": "Salvando...",
  "settings.profile.saved": "Perfil atualizado",
  "settings.org.title": "Configurações da Organização",
  "settings.org.subtitle": "Gerencie as informações do seu negócio",
  "settings.org.name": "Nome da Organização",
  "settings.org.type": "Tipo de Indústria",
  "settings.org.billingEmail": "E-mail de Cobrança",
  "settings.org.plan": "Plano",
  "settings.org.verification": "Status de Verificação",
  "settings.org.save": "Salvar Alterações",
  "settings.org.saving": "Salvando...",
  "settings.org.saved": "Organização atualizada",
  "settings.org.noOrg": "Nenhuma organização encontrada",
  "invite.language.title": "Escolha seu idioma",
  "invite.language.subtitle": "Mostraremos todas as instruções no seu idioma.",
  "invite.welcome.title": "Bem-vindo ao",
  "invite.welcome.subtitle": "Estamos prontos para receber seus documentos.",
  "invite.welcome.time": "5-10 minutos",
  "invite.welcome.timeLabel": "Tempo estimado",
  "invite.welcome.secure": "Seguro e Gratuito",
  "invite.welcome.secureDesc": "Seus documentos são criptografados. Este serviço é gratuito para você.",
  "invite.welcome.start": "Iniciar Envio",
  "invite.documents.needed": "Documentos necessários",
  "invite.upload.title": "Enviar Documento",
  "invite.upload.dragDrop": "Arraste e solte um arquivo aqui, ou clique para selecionar",
  "invite.upload.or": "ou",
  "invite.upload.takePhoto": "Imagens",
  "invite.upload.browse": "Arquivos",
  "invite.upload.uploading": "Enviando...",
  "invite.upload.analyzing": "Verificando documento...",
  "invite.upload.success": "Enviado com sucesso",
  "invite.upload.next": "Próximo Documento",
  "invite.upload.finish": "Revisar Todos",
  "invite.upload.skip": "Pular por agora",
  "invite.upload.progress": "Progresso",
  "invite.complete.title": "Tudo Pronto!",
  "invite.complete.subtitle": "Seus documentos foram enviados com sucesso.",
  "invite.complete.message": "Recebemos todos os seus documentos. Entraremos em contato em breve.",
  "invite.complete.summary": "Documentos enviados",
  "invite.complete.securityNote": "Seus documentos são armazenados de forma segura e só serão acessados por pessoal autorizado.",
  "invite.chat.title": "Chat com seu agente",
  "invite.chat.placeholder": "Digite uma mensagem...",
  "invite.chat.empty": "Ainda sem mensagens. Inicie uma conversa.",
  "invite.chat.sent": "Sua mensagem foi enviada.",
  "invite.chat.willRespond": "Responderemos assim que possível.",
  "invite.chat.sending": "Enviando...",
  "invite.error.title": "Link Inválido ou Expirado",
  "invite.error.message": "Este link de convite não é mais válido. Por favor, entre em contato com o remetente para um novo link.",
  "common.loading": "Carregando...",
  "common.save": "Salvar",
  "common.cancel": "Cancelar",
  "common.delete": "Excluir",
  "common.edit": "Editar",
  "common.create": "Criar",
  "common.close": "Fechar",
  "common.dismiss": "Dispensar",
  "common.confirm": "Confirmar",
  "common.back": "Voltar",
  "common.next": "Próximo",
  "common.previous": "Anterior",
  "common.of": "de",
  "common.search": "Buscar",
  "common.filter": "Filtrar",
  "common.sort": "Ordenar",
  "common.viewAll": "Ver todos",
  "common.refresh": "Atualizar",
  "common.retry": "Tentar novamente",
  "common.yes": "Sim",
  "common.no": "Não",
  "common.or": "ou",
  "common.and": "e",
  "common.optional": "opcional",
  "common.required": "obrigatório",
  "status.draft": "Rascunho",
  "status.active": "Ativo",
  "status.pending": "Pendente",
  "status.pending_documents": "Documentos Pendentes",
  "status.pending_signature": "Assinatura Pendente",
  "status.on_hold": "Em Espera",
  "status.closed": "Fechado",
  "status.cancelled": "Cancelado",
  "error.generic": "Algo deu errado. Por favor, tente novamente.",
  "error.network": "Erro de rede. Por favor, verifique sua conexão.",
  "error.unauthorized": "Você não está autorizado a realizar esta ação.",
  "error.notFound": "O recurso solicitado não foi encontrado.",
  "error.validation": "Por favor, verifique sua entrada e tente novamente.",
  "error.serverError": "Erro do servidor. Por favor, tente novamente mais tarde.",
  "success.saved": "Alterações salvas com sucesso.",
  "success.created": "Criado com sucesso.",
  "success.deleted": "Excluído com sucesso.",
  "success.sent": "Enviado com sucesso.",
  "success.uploaded": "Enviado com sucesso.",
  "time.justNow": "Agora mesmo",
  "time.minutesAgo": "há {count} minutos",
  "time.hoursAgo": "há {count} horas",
  "time.daysAgo": "há {count} dias",
  "time.today": "Hoje",
  "time.yesterday": "Ontem",
  "dealRoom.notFound": "Negócio não encontrado",
  "dealRoom.loading": "Carregando negócio...",
  "dealRoom.conversation.title": "Conversa do Negócio",
  "dealRoom.conversation.you": "Você",
  "dealRoom.conversation.client": "Cliente",
  "dealRoom.messages.hideOriginal": "Ocultar original",
  "dealRoom.messages.original": "Original ({language})",
  "dealRoom.messages.disabled": "Mensagens estão desabilitadas para este status de negócio",
  "dealRoom.messages.aiSuggest": "Resposta sugerida por IA",
  "dealRoom.documents.title": "Documentos",
  "dealRoom.documents.uploadDisabled": "Envio Desabilitado",
  "dealRoom.documents.pendingAnalysis": "Análise Pendente",
  "dealRoom.documents.uploadFirst": "Enviar Primeiro Documento",
  "dealRoom.documents.uploadHelp": "Envie documentos para este negócio para análise por IA",
  "dealRoom.documents.uploadDisabledHelp": "Envio de documentos está desabilitado para este status de negócio",
  "dealRoom.documents.analyzeWithAI": "Analisar com IA",
  "dealRoom.documents.notAnalyzed": "Ainda não analisado",
  "dealRoom.documents.notAnalyzedHelp": "Execute a análise por IA para extrair tipo de documento, campos e obter insights",
  "dealRoom.documents.analyzeDocument": "Analisar Documento",
  "dealRoom.documents.extractedFields": "Campos Extraídos",
  "dealRoom.documents.issuesDetected": "Problemas Detectados",
  "dealRoom.documents.preview": "Prévia",
  "dealRoom.documents.uploaded": "Enviado",
  "dealRoom.documents.deleteConfirm": "Tem certeza que deseja excluir este documento?",
  "dealRoom.onHold.message": "Este negócio está em espera. Envio de documentos está desabilitado. Você ainda pode enviar mensagens para coordenação.",
  "dealRoom.pendingSignature.message": "O contrato está pronto para assinatura. Envio de documentos está desabilitado até o contrato ser assinado ou revertido.",
  "dealRoom.status.current": "atual",
  "dealRoom.status.finalWarning": "Este é um estado final. O negócio não pode ser reaberto após esta ação.",
  "dealRoom.contract.purchaseAgreement": "Contrato de Compra e Venda",
  "dealRoom.contract.purchaseAgreementDesc": "Contrato padrão de compra e venda",
  "dealRoom.contract.noContract": "Ainda Sem Contrato",
  "dealRoom.contract.noContractDesc": "Gere um rascunho de contrato por IA baseado nos detalhes e documentos do negócio.",
  "dealRoom.contract.notAvailable": "Geração de contrato não está disponível para negócios {status}.",
  "dealRoom.contract.locked": "Geração de contrato está bloqueada enquanto aguarda assinatura.",
  "dealRoom.contract.requiresPlan": "Requer plano Business Starter",
  "dealRoom.toast.dealUpdated": "Negócio atualizado",
  "dealRoom.toast.statusChanged": "Status do negócio alterado para {status}",
  "dealRoom.toast.statusFailed": "Falha ao alterar status",
  "dealRoom.toast.contractGenerated": "Rascunho de contrato gerado com sucesso",
  "dealRoom.toast.contractCopied": "Contrato em {language} copiado para a área de transferência",
  "dealRoom.toast.messageFailed": "Falha ao enviar mensagem",
  "dealRoom.toast.suggestionFailed": "Falha ao gerar sugestão",
  "dealRoom.toast.documentUploaded": "Documento enviado",
  "dealRoom.toast.uploadFailed": "Falha no envio",
  "dealRoom.toast.analysisComplete": "Análise de documento por IA completa",
  "dealRoom.toast.analysisFailed": "Falha na análise por IA",
  "dealRoom.toast.documentDeleted": "Documento excluído",
  "dealRoom.toast.deleteFailed": "Falha ao excluir",
  "dealRoom.details.created": "Criado",
  "dealRoom.details.addNotes": "Adicionar notas do negócio...",
  "onboarding.brand": "PocketFiler",
  "onboarding.skip": "Pular por agora",
  "onboarding.badge": "Configuração com IA",
  "onboarding.welcome": "Bem-vindo, {name}!",
  "onboarding.welcomeGeneric": "Bem-vindo!",
  "onboarding.subtitle": "Vamos configurar seu espaço de trabalho PocketFiler. Conte ao nosso Concierge IA sobre seu negócio, e configuraremos tudo para você.",
  "onboarding.step1": "Descreva seu negócio e necessidades",
  "onboarding.step2": "IA sugere sua configuração",
  "onboarding.step3": "Comece a gerenciar negócios",
  "onboarding.concierge.title": "Concierge IA",
  "onboarding.toast.officeCreated": "Escritório virtual criado!",
  "auth.signup.accountType": "Tipo de Conta",
  "auth.signup.passwordTooShort": "A senha deve ter pelo menos 8 caracteres",
  "auth.signup.passwordsDoNotMatch": "As senhas não coincidem",
  "auth.signup.success": "Conta criada com sucesso!",
  "captions.connecting": "Conectando...",
  "captions.disable": "Desativar Legendas",
  "captions.enable": "Ativar Legendas",
  "captions.error.connect": "Falha ao conectar ao serviço de legendas",
  "captions.error.toggle": "Falha ao alternar legendas",
  "captions.language": "Idioma das Legendas",
  "captions.live": "Ao Vivo",
  "captions.off": "Legendas Desligadas",
  "captions.on": "Legendas Ligadas",
  "captions.original": "Original",
  "captions.translated": "Traduzido",
  "captions.translating": "Traduzindo...",
  "clients.joined.empty.desc": "Você ainda não participou de nenhuma organização. Peça para te convidarem para o espaço de trabalho PocketFiler deles.",
  "clients.joined.empty.title": "Nenhuma Organização Participante",
  "clients.nav.joinedOrgs": "Organizações Participantes",
  "clients.nav.myClients": "Meus Clientes",
  "clients.table.joinedDate": "Data de Entrada",
  "clients.table.organization": "Organização",
  "common.backToHome": "Voltar ao Início",
  "common.deleteConfirmDesc": "Esta ação não pode ser desfeita. Isto excluirá permanentemente o item e removerá os dados dos nossos servidores.",
  "common.deleteConfirmTitle": "Tem certeza absoluta?",
  "common.noResults": "Nenhum resultado encontrado",
  "connect.createAccount": "Criar Conta Gratuita",
  "connect.dealCreated": "Negócio criado com sucesso",
  "connect.error.invalid": "Link de Conexão Inválido",
  "connect.error.invalidDesc": "Este link de conexão é inválido ou expirou.",
  "connect.error.server": "Algo deu errado",
  "connect.error.serverDesc": "Tente novamente mais tarde.",
  "connect.infoUnauth": "Esta pessoa usa o PocketFiler para gerenciar negócios e documentos multilíngues com segurança.",
  "connect.joinOffice": "Entrar no Escritório Virtual",
  "connect.loggedInAs": "Conectado como",
  "connect.login": "Entrar",
  "connect.startDeal": "Iniciar um Negócio",
  "connect.titleAuth": "Você está se conectando com",
  "connect.titleUnauth": "Conectar com",
  "connect.typeOrg": "Organização",
  "connect.typePerson": "Pessoa",
  "contacts.actions.call": "Ligar",
  "contacts.actions.email": "Email",
  "contacts.actions.message": "Enviar Mensagem no App",
  "contacts.actions.noEmail": "Sem endereço de email",
  "contacts.actions.noPhone": "Sem número de telefone",
  "contacts.actions.sms": "Mensagem de Texto",
  "contacts.actions.title": "Contato {name}",
  "contacts.actions.whatsapp": "WhatsApp",
  "contacts.dialog.name": "Nome do Contato",
  "contacts.dialog.title": "Adicionar Novo Contato",
  "contacts.empty.desc": "Adicione seu primeiro contato para começar.",
  "contacts.empty.title": "Nenhum contato ainda",
  "contacts.invite": "Adicionar Contato",
  "contacts.invite.customNotePlaceholder": "Observações especiais sobre este contato...",
  "contacts.invite.nameLabel": "Nome do Contato",
  "contacts.invite.shareLink": "Compartilhe este link com seu contato via email, SMS ou pessoalmente",
  "contacts.invite.step1Desc": "Digite as informações do contato",
  "contacts.invite.step1Title": "Adicionar Novo Contato",
  "contacts.subtitle": "Gerencie seus contatos e convites",
  "contacts.table.contact": "Contato",
  "contacts.title": "Contatos",
  "contacts.toast.deleted": "Contato excluído",
  "contacts.toast.invited": "Contato adicionado: {name}",
  "contacts.toast.linkCopied": "Link copiado para área de transferência",
  "dashboard.quickActions.inviteContact": "Adicionar Contato",
  "dashboard.recentContacts.empty": "Nenhum contato ainda. Convide seu primeiro contato para começar.",
  "dashboard.recentContacts.title": "Contatos Recentes",
  "dashboard.recentContacts.viewAll": "Ver todos",
  "dashboard.stats.totalContacts": "Total de Contatos",
  "dealRoom.contract.analysisWarning": "Alguns documentos ainda não foram analisados. A análise de IA melhora a precisão do contrato.",
  "dealRoom.conversation.colleague": "Colega",
  "dealRoom.details.clients": "Clientes",
  "dealRoom.documents.previewNotAvailable": "Visualização não disponível. Baixando...",
  "dealRoom.incomingCall.accept": "Aceitar",
  "dealRoom.incomingCall.decline": "Recusar",
  "dealRoom.incomingCall.inProgress": "Chamada em andamento",
  "dealRoom.incomingCall.started": "{name} iniciou uma chamada",
  "dealRoom.messages.connecting": "Conectando ao chat...",
  "dealRoom.messages.connectionError": "Não foi possível conectar à conversa.",
  "dealRoom.pendingSignature.loading": "Carregando status da assinatura...",
  "dealRoom.pendingSignature.signedWaitingOthers": "Assinado com sucesso. Aguardando outros participantes.",
  "dealRoom.readOnly.completedMessage": "Este negócio foi concluído com sucesso. A Sala de Negócios agora é somente leitura para referência e auditoria.",
  "dealRoom.signature.signed": "Assinado",
  "dealRoom.signature.signedByYou": "Assinado por você",
  "dealRoom.signature.success": "Contrato assinado com sucesso!",
  "dealRoom.signaturesList.clients": "Clientes",
  "dealRoom.signaturesList.dealOwner": "Proprietário do negócio",
  "dealRoom.signaturesList.pending": "Pendente",
  "dealRoom.signaturesList.signedOn": "Assinado em",
  "dealRoom.signaturesList.title": "Assinaturas",
  "dealRoom.signaturesList.viewSignatures": "Ver assinaturas",
  "dealRoom.signedByAll.addPayment": "Adicionar Pagamento",
  "dealRoom.signedByAll.message": "Assinado por todos os participantes. Prossiga para Pagamento.",
  "dealRoom.timeline.createdBy": "por {name}",
  "deals.tabs.all": "Todos os Negócios",
  "deals.tabs.my": "Meus Negócios",
  "deals.validation.clientRequired": "Selecione pelo menos um cliente",
  "deals.validation.notesLength": "As observações devem ter 200 caracteres ou menos",
  "deals.validation.titleLength": "O título deve ter 100 caracteres ou menos",
  "deals.validation.titleRequired": "Título do negócio é obrigatório",
  "documents.readAloud.analyzeFirst": "Analise este documento primeiro para lê-lo em voz alta.",
  "documents.readAloud.error": "Falha na leitura em voz alta",
  "documents.readAloud.title": "Ler em voz alta",
  "landing.cta.secondary": "Ver Exemplo de Sala de Negócios",
  "landing.hero.trust": "Plano gratuito. Sem cartão de crédito. Suporte a 11 idiomas.",
  "landing.socialProof": "Confiado por mais de 500 empresas em 40 países",
  "landing.useCases.personal.desc": "Feche negócios importantes únicos como veículos, equipamentos ou propriedades com registros claros, contratos com IA e links seguros simples para compartilhamento de documentos.",
  "landing.useCases.personal.title": "Transações Pessoais de Alto Valor",
  "landing.useCases.professional.desc": "Convide clientes para enviar documentos com assistência de IA, acompanhe cada interação em Escritórios Virtuais Seguros e gere contratos digitais bilíngues—tudo em um único espaço de trabalho.",
  "landing.useCases.professional.subtitle": "Seguros, Imóveis, Empréstimos",
  "landing.useCases.professional.title": "Serviços Profissionais",
  "livekit.call": "Chamada",
  "livekit.connecting": "Conectando...",
  "livekit.error.connect": "Falha ao conectar na chamada. Tente novamente.",
  "livekit.error.connection": "Erro de conexão. Verifique sua rede e tente novamente.",
  "livekit.error.permission": "Você não tem permissão para entrar nesta chamada.",
  "livekit.hint": "Converse dentro desta Negociação em vez de trocar de apps.",
  "livekit.inCall": "Na Chamada",
  "livekit.joinCall": "Entrar na chamada",
  "livekit.leaveCall": "Sair da chamada",
  "livekit.participant": "participante",
  "livekit.participants": "participantes",
  "messages.readAloud.error": "Falha na leitura em voz alta",
  "messages.readAloud.title": "Ler em voz alta",
  "nav.companyProfile": "Perfil da Empresa",
  "nav.contacts": "Contatos",
  "nav.directory": "Diretório",
  "nav.products": "Produtos",
  "offices.card.contacts": "{count} contatos",
  "pwa.banner.install": "Instalar",
  "pwa.banner.subtitle": "Acesso mais rápido, funciona offline",
  "pwa.banner.title": "Baixe o App PocketFiler",
  "pwa.firefox.hint": "No Firefox, procure o ícone de instalação (⊕) na barra de endereços para adicionar este app à sua área de trabalho.",
  "pwa.installApp": "Instalar App",
  "pwa.installed": "App instalado com sucesso!",
  "pwa.ios.description": "Adicione o PocketFiler à sua tela inicial para a melhor experiência:",
  "pwa.ios.gotIt": "Entendi",
  "pwa.ios.inToolbar": "na barra de ferramentas do seu navegador",
  "pwa.ios.inTopRight": "no canto superior direito",
  "pwa.ios.shareButton": "botão Compartilhar",
  "pwa.ios.step1": "Toque no",
  "pwa.ios.step2": "Role para baixo e toque em",
  "pwa.ios.step3": "Toque em",
  "pwa.ios.title": "Instalar PocketFiler",
  "pwa.iosHint": "Toque no ícone Compartilhar e \"Adicionar à Tela de Início\" para instalar o PocketFiler.",
  "pwa.opera.chromeHint": "abra esta página, depois clique no ícone de instalação na barra de endereços",
  "pwa.opera.desktopNotSupported": "O Opera desktop não suporta instalação de PWA. Para instalar o PocketFiler como um app, abra no Google Chrome ou Microsoft Edge.",
  "pwa.opera.edgeHint": "abra esta página, depois clique no ícone de instalação (⊕) na barra de endereços",
  "pwa.opera.mobileAddPage": "Adicionar página à",
  "pwa.opera.mobileDescription": "Toque no ícone + na parte inferior do Opera, ou use o menu abaixo:",
  "pwa.opera.mobileHomeScreen": "Tela inicial",
  "pwa.opera.mobileStep1": "Toque no",
  "pwa.opera.mobileStep1b": "ícone mais (+) na barra inferior do Opera",
  "pwa.opera.mobileStep2": "Ou toque em",
  "pwa.opera.mobileTitle": "Instalar PocketFiler no Opera",
  "pwa.opera.recommendedBrowsers": "Use em vez disso:",
  "pwa.opera.title": "Não disponível no Opera",
  "qr.clickToExpand": "Clique para ver em tela cheia",
  "qr.copied": "Copiado!",
  "qr.copyLink": "Copiar Link",
  "qr.description": "Mostre este código para clientes ou parceiros. Quando escanearem, podem se conectar com você e iniciar um negócio em segundos.",
  "qr.download": "Baixar",
  "qr.generate": "Gerar Código QR",
  "qr.linkCopied": "Link copiado para área de transferência",
  "qr.primaryLanguage": "Idioma principal",
  "qr.regenerate": "Redefinir",
  "qr.regenerated": "Código QR regenerado. Links antigos agora são inválidos.",
  "qr.scanInstructions": "Escaneie este QR com PocketFiler ou qualquer leitor de QR para conectar.",
  "qr.scanToConnect": "Escaneie para Conectar",
  "qr.share": "Compartilhar",
  "qr.title": "Compartilhe seu QR do PocketFiler",
  "qr.yourLink": "Seu link de conexão:",
  "recording.completed": "Gravação concluída",
  "recording.confirmDelete": "Excluir esta gravação?",
  "recording.delete": "Excluir",
  "recording.deleted": "Gravação excluída",
  "recording.download": "Baixar",
  "recording.error.delete": "Falha ao excluir gravação",
  "recording.error.noCall": "Nenhuma chamada ativa. Entre na chamada primeiro.",
  "recording.error.start": "Falha ao iniciar gravação",
  "recording.error.stop": "Falha ao parar gravação",
  "recording.failed": "Gravação falhou",
  "recording.noRecordings": "Nenhuma gravação ainda",
  "recording.play": "Reproduzir",
  "recording.playback": "Reprodução da Gravação",
  "recording.processing": "Processando...",
  "recording.start": "Gravar",
  "recording.started": "Gravação iniciada",
  "recording.stop": "Parar",
  "recording.stopped": "Gravação parada. Processando...",
  "recording.viewRecordings": "Ver Gravações",
  "schedule.button": "Agendar",
  "schedule.cancel": "Cancelar",
  "schedule.chooseDateTime": "Escolha data e horário",
  "schedule.create": "Agendar",
  "schedule.created": "Agendado",
  "schedule.dateTime": "Data e horário",
  "schedule.description": "Escolha uma data e horário. Você pode entrar na chamada quando chegar a hora.",
  "schedule.title": "Agendar chamada ou gravação",
  "schedule.type": "Tipo",
  "schedule.typeCall": "Chamada",
  "schedule.typeRecording": "Gravação",
  "schedule.upcoming": "Próximos agendados",
  "settings.profile.accountType": "Tipo de Conta",
  "settings.profile.accountTypeHelp": "Escolha o tipo que melhor te descreve",
  "settings.tabs.sharing": "Compartilhar QR",
  "support.askAI": "Perguntar à IA",
  "support.availableTimes": "Horários disponíveis",
  "support.booked": "Ligação agendada com sucesso!",
  "support.bookingConfirmed": "Ótimo, agendei sua ligação para {time}. Você receberá uma confirmação com o link da chamada. Posso ajudar com mais alguma coisa?",
  "support.bookingError": "Falha ao agendar horário. Tente novamente.",
  "support.clearChat": "Limpar conversa",
  "support.error": "Falha ao enviar mensagem. Tente novamente.",
  "support.inYourTime": "no seu horário local",
  "support.inputPlaceholder": "Digite sua pergunta...",
  "support.openChat": "Abrir suporte IA",
  "support.scheduleCall": "Agendar ligação com suporte",
  "support.scheduleTitle": "Agendar Ligação de Suporte",
  "support.slotsError": "Falha ao carregar horários disponíveis.",
  "support.subtitle": "Pergunte qualquer coisa sobre o PocketFiler",
  "support.title": "Suporte IA",
  "support.welcome": "Oi! Sou o assistente de IA do PocketFiler. Posso te ajudar com:\\n\\n- Criar e gerenciar negócios\\n- Enviar documentos para assinatura\\n- Usar o recurso de conexão QR\\n- Convidar clientes\\n- Qualquer outra pergunta sobre o PocketFiler\\n\\nComo posso te ajudar hoje?",
  "support.yourTimezone": "Seu fuso horário",
  "validation.emailInvalid": "Formato de email inválido",
  "validation.emailRequired": "Email é obrigatório",
  "validation.nameRequired": "Nome é obrigatório",
  "validation.nameTooLong": "Nome deve ter menos de 50 caracteres",
  "validation.noteTooLong": "Observação deve ter menos de 200 caracteres",
  "validation.phoneInvalid": "Número de telefone inválido (10-15 dígitos)",
  "validation.phoneRequired": "Número de telefone é obrigatório",
  "deals.column.cancelled": "Cancelado",
  "deals.column.completed": "Concluído",
  "deals.column.disputed": "Disputado",
  "deals.column.escrow_funded": "Garantia financiada",
  "deals.column.on_hold": "Em espera",
  "deals.column.pending_documents": "Documentos pendentes",
  "deals.column.pending_payment": "Pagamento pendente",
  "deals.column.pending_signature": "Assinatura pendente",
  "deals.column.release_requested": "Liberação solicitada",
  "dashboard.actions.addClient": "Adicionar Cliente",
  "dashboard.actions.all": "Todos",
  "dashboard.actions.createContract": "Criar Contrato",
  "dashboard.actions.createInvoice": "Criar Fatura",
  "dashboard.actions.customize": "Personalizar",
  "dashboard.actions.newDeal": "Novo Negócio",
  "dashboard.actions.scheduleMeeting": "Agendar Reunião",
  "dashboard.actions.uploadDocument": "Enviar Documento",
  "dashboard.actions.viewAll": "Ver Todos",
  "dashboard.briefing.default": "Nada urgente no momento. Seu workspace está em boa forma.",
  "dashboard.briefing.title": "Resumo Diário",
  "dashboard.empty.activity": "Nenhuma atividade recente.",
  "dashboard.empty.deals": "Nenhum negócio ainda. Crie seu primeiro negócio para ver o pipeline.",
  "dashboard.empty.documents": "Todos os documentos estão atualizados.",
  "dashboard.empty.meetings": "Nenhuma reunião agendada.",
  "dashboard.empty.tasks": "Nenhuma tarefa em aberto.",
  "dashboard.greeting.afternoon": "Boa tarde",
  "dashboard.greeting.evening": "Boa noite",
  "dashboard.greeting.morning": "Bom dia",
  "dashboard.greeting.subtitle": "Aqui está o que está acontecendo no seu workspace.",
  "dashboard.stats.documents": "Documentos",
  "dashboard.stats.invoicesDue": "Faturas Vencendo",
  "dashboard.stats.meetingsComing": "Próximas Reuniões",
  "dashboard.stats.tasksDue": "Tarefas Pendentes",
  "dashboard.stats.unreadMessages": "Mensagens Não Lidas",
  "dashboard.widgets.dealPipeline": "Pipeline de Negócios",
  "dashboard.widgets.documentsAttention": "Documentos Precisando de Atenção",
  "dashboard.widgets.gettingStarted": "Primeiros Passos",
  "dashboard.widgets.quickActions": "Ações Rápidas",
  "dashboard.widgets.recentActivity": "Atividade Recente",
  "dashboard.widgets.tasks": "Tarefas",
  "dashboard.widgets.upcomingMeetings": "Próximas Reuniões",
  "dashboard.steps.createDeal": "Crie seu primeiro negócio",
  "dashboard.steps.addClient": "Adicionar um cliente",
  "dashboard.steps.uploadDocument": "Enviar um documento",
  "dashboard.steps.scheduleMeeting": "Agendar uma reunião",
  "dashboard.steps.createInvoice": "Criar uma fatura",
  "dashboard.steps.addLogo": "Adicionar seu logo",
  "dashboard.steps.complete": "concluído",
  "dashboard.time.overdue": "Atrasado",
  "dashboard.time.today": "Hoje",
  "dashboard.time.tomorrow": "Amanhã",
  "dashboard.time.noDate": "Sem data",
  "dashboard.docReason.sent": "Enviado, aguardando resposta",
  "dashboard.docReason.notAnalyzed": "Ainda não analisado",
  "dashboard.docReason.draft": "Rascunho, não finalizado",
  "dashboard.docReason.needsReview": "Precisa de revisão",
  "docViewer.notFound": "Documento não encontrado",
  "docViewer.previewUnavailable": "Visualização não disponível para este tipo de arquivo",
  "docViewer.aiAnalysis": "Análise AI",
  "docViewer.documentType": "Tipo de Documento",
  "docViewer.summary": "Resumo",
  "docViewer.extractedFields": "Campos Extraídos",
  "docViewer.issues": "Problemas",
  "docViewer.tags": "Etiquetas",
  "docViewer.noPreviousVersions": "Nenhuma versão anterior",
  "docViewer.noActivity": "Nenhuma atividade ainda",
  "auth.forgotPassword.title": "Redefinir sua senha",
  "guestSign.loading": "Carregando contrato...",
  "guestSign.unableToLoad": "Não foi possível carregar o contrato",
  "guestSign.signed": "Contrato assinado",
  "guestSign.createOwn": "Deseja criar e gerenciar seus próprios contratos?",
  "guestSign.secureSign": "Assinatura segura",
  "meeting.ended": "Esta reunião foi encerrada",
  "meeting.cancelled": "Reunião cancelada",
  "meeting.notFound": "Reunião não encontrada",
  "meeting.joiningAs": "Ingressando como",
  "meeting.yourName": "Seu nome *",
  "meeting.emailOptional": "Email (opcional)",
  "notFound.title": "Página não encontrada",
  "notFound.dashboard": "Ir para o painel",
  "notFound.home": "Início",
  "auth.resetPassword.invalidLink": "Link inválido",
  "auth.resetPassword.title": "Definir nova senha",
  "templates.category": "Categoria",
  "templates.legal": "Jurídico",
  "templates.sales": "Vendas",
  "templates.services": "Serviços",
  "templates.finance": "Finanças",
  "templates.library": "Biblioteca de modelos",
  "templates.libraryDesc": "Modelos de documento prontos para uso em seus negócios",
  "templates.noDefault": "Nenhum modelo padrão corresponde à sua pesquisa.",
  "templates.noCustom": "Nenhum modelo personalizado encontrado",
  "templates.delete": "Excluir modelo",
  "templates.cancel": "Cancelar",
  "uploadRequest.notFound": "Solicitação não encontrada",
  "uploadRequest.error": "Algo deu errado",
  "uploadRequest.errorDesc": "Tente novamente mais tarde ou entre em contato com a pessoa que enviou esta solicitação.",
  "uploadRequest.uploaded": "Documentos enviados!",
  "uploadRequest.title": "Solicitação de envio de documento",
  "uploadRequest.fileTypes": "PDF, imagens, documentos Word - máximo 25MB",
  "verify.verifying": "Verificando seu email...",
  "verify.success": "Email verificado!",
  "verify.signIn": "Entrar",
  "verify.alreadyVerified": "Já verificado",
  "verify.invalidLink": "Link inválido",
  "verify.backToLogin": "Voltar ao login",
  "documents.documents": "Documentos",
  "documents.allStatus": "Todos os Estados",
  "documents.newFolder": "Nova Pasta",
  "documents.clear": "Limpar",
  "documents.noDocumentsYet": "Ainda não há documentos",
  "documents.status": "Estado",
  "documents.type": "Tipo",
  "documents.uploadedBy": "Carregado por",
  "documents.previewNotAvailable": "Pré-visualização não disponível",
  "documents.aiAnalysis": "Análise AI",
  "documents.documentType": "Tipo de Documento",
  "documents.summary": "Resumo",
  "documents.extractedFields": "Campos Extraídos",
  "documents.issues": "Questões",
  "documents.notYetAnalyzed": "Ainda não analisado",
  "documents.details": "Detalhes",
  "documents.size": "Tamanho",
  "documents.date": "Data",
  "documents.mimeType": "Tipo MIME",
  "documents.noTags": "Sem etiquetas",
  "documents.changeStatus": "Alterar Estado",
  "documents.versionHistory": "Histórico de Versões",
  "documents.noPreviousVersions": "Não há versões anteriores",
  "documents.activityLog": "Registo de Atividade",
  "documents.noActivityRecordedYet": "Ainda não foi registada qualquer atividade",
  "documents.uploadDocuments": "Carregar Documentos",
  "documents.dragAndDropFiles": "Arraste e largue ficheiros ou clique para navegar. São suportados PDF, imagens e documentos Word.",
  "documents.shareDocument": "Partilhar Documento",
  "documents.done": "Concluído",
  "documents.emailOptional": "E-mail (opcional)",
  "documents.leaveEmptyToJust": "Deixe vazio para apenas gerar uma ligação",
  "documents.messageOptional": "Mensagem (opcional)",
  "documents.cancel": "Cancelar",
  "documents.requestDocuments": "Solicitar Documentos",
  "documents.sendASecureUpload": "Envie uma ligação de carregamento segura para um cliente por e-mail.",
  "documents.clientEmail": "E-mail do Cliente *",
  "documents.clientName": "Nome do Cliente",
  "documents.requestedDocuments": "Documentos Solicitados *",
  "documents.renameFolder": "Renomear Pasta",
  "documents.selectADestinationFolder": "Selecione uma pasta de destino.",
  "documents.deleteDocument": "Eliminar documento?",
  "settings.individual": "Individual",
  "settings.business": "Empresa",
  "settings.buyer": "Comprador",
  "settings.seller": "Vendedor",
  "settings.chooseYourPreferredTheme": "Escolha o seu tema preferido",
  "settings.light": "Claro",
  "settings.dark": "Escuro",
  "settings.system": "Sistema",
  "settings.manufacturing": "Fabrico",
  "settings.insurance": "Seguros",
  "settings.realEstate": "Imobiliário",
  "settings.automotive": "Automóvel",
  "settings.importexport": "Importação/Exportação",
  "settings.other": "Outro",
  "settings.brandingWhitelabel": "Marca e White-Label",
  "settings.customizeThePocketfilerExperience": "Personalize a experiência PocketFiler para os seus clientes.",
  "settings.organizationLogo": "Logótipo da Organização",
  "settings.provideADirectLink": "Forneça uma ligação direta para o seu logótipo PNG ou SVG transparente.",
  "settings.primaryThemeColor": "Cor Primária do Tema",
  "settings.selectAHexColor": "Selecione um código de cor hexadecimal para representar os acentos primários da sua marca.",
  "settings.accentHoverColor": "Cor de Destaque / Hover",
  "settings.selectAHexColor1": "Selecione uma cor hexadecimal para estados hover, destaques e elementos de acento.",
  "settings.customDomain": "Domínio Personalizado",
  "settings.ensureYouConfigureA": "Certifique-se de que configura um registo CNAME que aponta para pocketfiler.com.",
  "settings.cancellationScheduled": "Cancelamento agendado",
  "settings.yourLastPaymentFailed": "O seu último pagamento falhou. Por favor, atualize o seu método de pagamento para manter o acesso.",
  "settings.chooseYourPlan": "Escolha o Seu Plano",
  "settings.monthly": "Mensal",
  "settings.save20": "Poupe 20%",
  "settings.current": "Atual",
  "settings.popular": "Popular",
  "settings.contactSales": "Contactar Vendas",
  "settings.googleCalendar": "Google Calendar",
  "settings.syncYourPocketfilerMeetings": "Sincronize as suas reuniões PocketFiler com Google Calendar",
  "settings.settingsPageErrorDebug": "Erro da Página de Definições (debug)",
  "invoices.createInvoice": "Criar Fatura",
  "invoices.createANewInvoice": "Crie uma nova fatura para um cliente",
  "invoices.selectClient": "Selecionar Cliente",
  "invoices.dueDate": "Data de Vencimento",
  "invoices.clientName": "Nome do Cliente",
  "invoices.clientEmail": "E-mail do Cliente",
  "invoices.lineItems": "Itens de Linha",
  "invoices.description": "Descrição",
  "invoices.qty": "Qtd",
  "invoices.price": "Preço",
  "invoices.tax": "IVA %",
  "invoices.total": "Total",
  "invoices.subtotal": "Subtotal:",
  "invoices.discount": "Desconto:",
  "invoices.tax1": "IVA:",
  "invoices.total1": "Total:",
  "invoices.notesOptional": "Notas (opcional)",
  "invoices.invoices": "Faturas",
  "invoices.manageAndTrackYour": "Gira e acompanha as suas faturas",
  "invoices.totalInvoiced": "Total Faturado",
  "invoices.paid": "Pago",
  "invoices.outstanding": "Em Dívida",
  "invoices.totalInvoices": "Total de Faturas",
  "invoices.allInvoices": "Todas as Faturas",
  "invoices.myInvoices": "Minhas Faturas",
  "invoices.receivedInvoices": "Faturas Recebidas",
  "invoices.noInvoicesYet": "Ainda não há faturas",
  "meetings.join": "Participar",
  "meetings.end": "Terminar",
  "meetings.meetingTitle": "Título da Reunião",
  "meetings.date": "Data",
  "meetings.time": "Hora",
  "meetings.duration": "Duração",
  "meetings.repeat": "Repetir",
  "meetings.doesNotRepeat": "Não se repete",
  "meetings.weekly": "Semanal",
  "meetings.every2Weeks": "A cada 2 semanas",
  "meetings.monthly": "Mensal",
  "meetings.invitePeopleOptional": "Convidar Pessoas (opcional)",
  "meetings.cancel": "Cancelar",
  "meetings.meetings": "Reuniões",
  "companyprofile.companyProfile": "Perfil da Empresa",
  "companyprofile.manageYourBusinessProfile": "Gerir o perfil da sua empresa e equipa",
  "companyprofile.publicProfile": "Perfil Público",
  "companyprofile.basicInformation": "Informações Básicas",
  "companyprofile.essentialDetailsAboutYour": "Detalhes essenciais sobre a sua empresa",
  "companyprofile.companyName": "Nome da Empresa",
  "companyprofile.tagline": "Slogan",
  "companyprofile.industry": "Setor",
  "companyprofile.companyType": "Tipo de Empresa",
  "companyprofile.description": "Descrição",
  "companyprofile.companyDetails": "Detalhes da Empresa",
  "companyprofile.additionalInformationAboutYour": "Informações adicionais sobre o seu negócio",
  "companyprofile.yearEstablished": "Ano de Fundação",
  "companyprofile.numberOfEmployees": "Número de Funcionários",
  "companyprofile.certifications": "Certificações",
  "companyprofile.enterCertificationsSeparatedBy": "Introduza as certificações separadas por vírgulas",
  "companyprofile.languagesSpoken": "Idiomas Falados",
  "companyprofile.shippingRegions": "Regiões de Envio",
  "companyprofile.contactInformation": "Informações de Contacto",
  "companyprofile.howPotentialPartnersCan": "Como os potenciais parceiros podem contactá-lo",
  "companyprofile.website": "Website",
  "companyprofile.email": "Email",
  "companyprofile.phone": "Telefone",
  "companyprofile.country": "País",
  "companyprofile.city": "Cidade",
  "companyprofile.address": "Morada",
  "companyprofile.teamMembers": "Membros da Equipa",
  "companyprofile.manageUsersWithinYour": "Gerir utilizadores dentro da sua organização",
  "companyprofile.role": "Função",
  "companyprofile.admin": "Administrador",
  "companyprofile.member": "Membro",
  "companyprofile.viewer": "Visualizador",
  "companyprofile.titleOptional": "Título (opcional)",
  "companyprofile.name": "Nome",
  "companyprofile.title": "Título",
  "companyprofile.status": "Estado",
  "companyprofile.actions": "Ações",
  "companyprofile.owner": "Proprietário",
  "companyprofile.copyInviteLink": "Copiar Link de Convite",
  "companyprofile.removeMember": "Remover Membro",
  "companyprofile.removeTeamMember": "Remover Membro da Equipa",
  "companyprofile.cancel": "Cancelar",
  "products.productsServices": "Produtos e Serviços",
  "products.description": "Descrição",
  "products.pricing": "Preços",
  "products.price": "Preço",
  "products.unit": "Unidade",
  "products.details": "Detalhes",
  "products.minOrderQty": "Qtd. Mín. Encomenda",
  "products.leadTime": "Prazo de Entrega",
  "products.category": "Categoria",
  "products.currency": "Moeda",
  "products.leadTimeDays": "Prazo de Entrega (dias)",
  "products.active": "Ativo",
  "products.showInCatalog": "Mostrar no catálogo",
  "products.cancel": "Cancelar",
  "developersettings.reveal": "Revelar",
  "developersettings.copy": "Copiar",
  "developersettings.hide": "Ocultar",
  "developersettings.securityWarning": "Aviso de Segurança",
  "developersettings.neverShareThisKey": "Nunca partilhe esta chave publicamente ou em código do lado do cliente",
  "developersettings.anyoneWithThisKey": "Qualquer pessoa com esta chave pode ler e modificar os seus dados",
  "developersettings.ifCompromisedRevokeImmediately": "Se comprometida, revogue imediatamente e gere uma nova chave",
  "developersettings.iUnderstandAndAccept": "Compreendo e aceito a responsabilidade pela segurança desta chave",
  "developersettings.cancel": "Cancelar",
  "developersettings.revealKey": "Revelar Chave",
  "developersettings.accessDenied": "Acesso Negado",
  "developersettings.onlyBusinessAccountsHave": "Apenas as contas empresariais têm acesso às Configurações de Desenvolvedor.",
  "developersettings.developerOverview": "Visão Geral do Desenvolvedor",
  "developersettings.manageYourApiKeys": "Gerir as suas chaves API e endpoints Webhook para integrações de terceiros.",
  "developersettings.secretApiKeys": "Chaves API Secretas",
  "developersettings.interactiveApiDocumentationRarr": "Documentação API Interativa &rarr;",
  "developersettings.name": "Nome",
  "developersettings.key": "Chave",
  "developersettings.createdAt": "Criado Em",
  "developersettings.status": "Estado",
  "developersettings.actions": "Ações",
  "developersettings.webhookEndpoints": "Endpoints Webhook",
  "developersettings.url": "URL",
  "developersettings.events": "Eventos",
  "developersettings.description": "Descrição",
  "developersettings.done": "Concluído",
  "developersettings.addWebhookEndpoint": "Adicionar Endpoint Webhook",
  "developersettings.payloadUrl": "URL do Payload",
  "developersettings.eventsToSend": "Eventos para enviar",
  "developersettings.sendMeEverything": "Enviar-me tudo (*)",
  "developersettings.dealStatusChangedDealstatuschanged": "Status do Negócio Alterado (deal.status_changed)",
  "developersettings.documentUploadedDocumentuploaded": "Documento Carregado (document.uploaded)",
  "developersettings.descriptionOptional": "Descrição (Opcional)",
  "analytics.noDataAvailableFor": "Nenhum dado disponível para este período.",
  "analytics.noDealsFound": "Nenhum negócio encontrado.",
  "analytics.noClientDataAvailable": "Nenhum dado de cliente disponível para este período.",
  "analytics.client": "Cliente",
  "analytics.invoices": "Faturas",
  "analytics.revenue": "Receita",
  "analytics.totalPipeline": "Pipeline Total",
  "analytics.noRecentActivityFor": "Nenhuma atividade recente para este período.",
  "analytics.pipelineOverview": "Visão Geral do Pipeline",
  "analytics.goToDeals": "Ir para Negócios",
  "analytics.analyticsDashboard": "Painel de Analytics",
  "analytics.trackYourBusinessPerformance": "Acompanhe o desempenho e insights do seu negócio",
  "analytics.last7Days": "Últimos 7 dias",
  "analytics.last30Days": "Últimos 30 dias",
  "analytics.last90Days": "Últimos 90 dias",
  "analytics.lastYear": "Último ano",
  "analytics.overview": "Visão Geral",
  "analytics.myPerformance": "Meu Desempenho",
  "analytics.currentDealsByStatus": "Negócios atuais por status",
  "analytics.revenueTrendsOverLast": "Tendências de receita nos últimos 6 meses",
  "analytics.accountsGeneratingTheMost": "Contas que geram mais receita",
  "analytics.currentCashFlowOverview": "Visão geral do fluxo de caixa atual",
  "analytics.latestBusinessActivitiesAnd": "Últimas atividades comerciais e atualizações",
  "compliance.complianceCenter": "Centro de Conformidade",
  "compliance.hsCodesTariffsSanctions": "Códigos HS, tarifas, triagem de sanções e controles de exportação",
  "compliance.hsCodeClassification": "Classificação de Código HS",
  "compliance.productDescription": "Descrição do Produto",
  "compliance.tariffCalculator": "Calculadora de Tarifas",
  "compliance.estimateImportDutiesBased": "Estime taxas de importação baseadas no código HS e rota comercial.",
  "compliance.hsCode": "Código HS",
  "compliance.declaredValueUsd": "Valor Declarado (USD)",
  "compliance.originCountry": "País de Origem",
  "compliance.destinationCountry": "País de Destino",
  "compliance.dutyRate": "Taxa de Imposto:",
  "compliance.totalRate": "Taxa Total:",
  "compliance.estDuty": "Imposto Est.:",
  "compliance.totalEstCost": "Custo Total Est.:",
  "compliance.tradeAgreements": "Acordos Comerciais:",
  "compliance.sanctionsScreening": "Triagem de Sanções",
  "compliance.screenEntitiesAgainstOfac": "Triar entidades contra a lista SDN da OFAC e sanções por país.",
  "compliance.entityName": "Nome da Entidade",
  "compliance.type": "Tipo",
  "compliance.company": "Empresa",
  "compliance.individual": "Indivíduo",
  "compliance.vessel": "Embarcação",
  "compliance.countryOptional": "País (opcional)",
  "compliance.usSanctionedCountries": "Países Sancionados pelos EUA",
  "compliance.exportControlCheck": "Verificação de Controle de Exportação",
  "compliance.aipoweredEaritarClassificationGuidance": "Orientação de classificação EAR/ITAR alimentada por IA. Não constitui aconselhamento jurídico.",
  "compliance.producttechnologyDescription": "Descrição do Produto/Tecnologia",
  "compliance.hsCodeOptional": "Código HS (opcional)",
  "compliance.endUseOptional": "Uso Final (opcional)",
  "compliance.licenseRequired": "Licença Necessária",
  "compliance.recommendations": "Recomendações:",
  "compliance.complianceHistory": "Histórico de Conformidade",
  "compliance.recentComplianceChecksFor": "Verificações de conformidade recentes para sua organização.",
  "compliance.noComplianceChecksYet": "Ainda não há verificações de conformidade. Execute sua primeira verificação acima.",
  "intelligence.marketIntelligence": "Inteligência de Mercado",
  "intelligence.anonymizedTradeDataAnd": "Dados comerciais anonimizados e benchmarks da plataforma PocketFiler",
  "intelligence.demandByCategory": "Demanda por Categoria",
  "intelligence.whatBuyersAreSourcing": "O que os compradores estão buscando na plataforma (últimos 90 dias)",
  "intelligence.noDemandDataYet": "Ainda não há dados de demanda. Os dados são preenchidos conforme RFQs são criados na plataforma.",
  "intelligence.byIndustry": "Por Setor",
  "intelligence.noSupplierDataYet": "Ainda não há dados de fornecedor.",
  "intelligence.byCountry": "Por País",
  "intelligence.byType": "Por Tipo",
  "intelligence.byVerification": "Por Verificação",
  "intelligence.noDataYet": "Ainda não há dados.",
  "intelligence.yourPerformanceVsPlatform": "Seu Desempenho vs Plataforma",
  "intelligence.seeHowYouStack": "Veja como você se compara às médias da plataforma",
  "intelligence.completeSomeDealsTo": "Complete alguns negócios para ver benchmarks.",
  "virtualoffices.virtualOffices": "Escritórios Virtuais",
  "virtualoffices.manageYourBrandedWorkspaces": "Gerencie seus espaços de trabalho com marca própria",
  "virtualoffices.officeName": "Nome do Escritório",
  "virtualoffices.industry": "Setor",
  "virtualoffices.languagesServed": "Idiomas Atendidos",
  "virtualoffices.descriptionOptional": "Descrição (opcional)",
  "virtualoffices.documentChecklist": "Lista de Verificação de Documentos",
  "virtualoffices.languages": "Idiomas",
  "tasks.tasks": "Tarefas",
  "tasks.noTasksYet": "Ainda não há tarefas",
  "tasks.dragTasksHere": "Arraste tarefas aqui",
  "tasks.createNewTask": "Criar Nova Tarefa",
  "tasks.descriptionOptional": "Descrição (Opcional)",
  "tasks.relatedDealOptional": "Negócio Relacionado (Opcional)",
  "tasks.noDealAttached": "Nenhum negócio anexado",
  "tasks.assignees": "Responsáveis",
  "tasks.noTeamMembersAvailable": "Nenhum membro da equipe disponível. Apenas membros ativos podem ser atribuídos.",
  "tasks.cancel": "Cancelar",
  "tasks.description": "Descrição",
  "tasks.status": "Status",
  "tasks.relatedDeal": "Negócio relacionado",
  "tasks.noAssignees": "Nenhum responsável",
  "tasks.areYouAbsolutelySure": "Tem absoluta certeza?",
  "events.events": "Eventos",
  "events.tradeShowsWebinarsAnd": "Feiras comerciais, webinars e eventos de networking",
  "events.createEvent": "Criar Evento",
  "events.title": "Título",
  "events.description": "Descrição",
  "events.category": "Categoria",
  "events.type": "Tipo",
  "events.locationUrl": "Localização / URL",
  "events.startDateTime": "Data e Hora de Início",
  "events.endDateTime": "Data e Hora de Término",
  "events.maxAttendeesOptional": "Máximo de Participantes (opcional)",
  "events.cancel": "Cancelar",
  "events.allCategories": "Todas as Categorias",
  "events.noEventsFoundCreate": "Nenhum evento encontrado. Crie o primeiro!",
  "events.featured": "Destaque",
  "events.previous": "Anterior",
  "events.next": "Próximo",
  "status.pendingDocuments": "Documentos Pendentes",
  "status.pendingSignature": "Assinatura Pendente",
  "status.pendingPayment": "Pagamento Pendente",
  "status.completed": "Concluído",
  "status.updated": "Atualizado",
  "status.onHold": "Em Espera",
  "activity.deal": "Negócio",
  "activity.action.analyzed": "Analisado",
  "activity.action.uploaded": "Carregado",
  "activity.action.downloaded": "Baixado",
  "activity.action.previewed": "Visualizado",
  "activity.action.shared": "Compartilhado",
  "activity.action.status_changed": "Status alterado",
  "activity.action.updated": "Atualizado",
  "activity.action.created": "Criado",
  "activity.action.archived": "Arquivado",
  "activity.action.restored": "Restaurado",
  "analytics.totalRevenue": "Receita Total",
  "analytics.totalDeals": "Total de Negócios",
  "analytics.conversionRate": "Taxa de Conversão",
  "analytics.avgDealValue": "Valor Médio por Negócio",
  "analytics.dealPipeline": "Pipeline de Negócios",
  "analytics.monthlyRevenue": "Receita Mensal",
  "analytics.topClientsByRevenue": "Principais Clientes por Receita",
  "analytics.invoiceHealth": "Situação das Faturas",
  "analytics.paid": "Pago",
  "analytics.pendingPayment": "Pagamento Pendente",
  "companyprofile.saveProfile": "Salvar Perfil",
  "companyprofile.makeVisible": "Torne a sua empresa visível no diretório",
  "companyprofile.tab.basicInfo": "Informações Básicas",
  "companyprofile.tab.details": "Detalhes",
  "companyprofile.tab.contact": "Contacto",
  "companyprofile.tab.team": "Equipa",
  "companyprofile.tab.verification": "Verificação",
  "companyprofile.selectType": "Selecionar tipo",
  "companyprofile.describePlaceholder": "Descreva a sua empresa, produtos e serviços...",
  "companyprofile.industry.other": "Outro",
  "companyprofile.preview": "Visualizar",
  "companyprofile.ph.companyName": "Sua Empresa Ltda.",
  "companyprofile.ph.tagline": "Produtos de qualidade, alcance global",
  "companyprofile.ph.selectIndustry": "Selecionar setor",
  "companyprofile.ph.selectSize": "Selecionar tamanho",
  "companyprofile.ph.certifications": "ISO 9001, CE, FDA (separados por vírgula)",
  "companyprofile.ph.languages": "Português, Espanhol, Chinês",
  "companyprofile.ph.exportRegions": "América do Norte, Europa, Ásia",
  "companyprofile.ph.selectCountry": "Selecionar país",
  "companyprofile.ph.city": "São Paulo",
  "companyprofile.ph.teamName": "Nome do membro da equipe",
  "companyprofile.ph.addTitle": "Adicionar título...",
  "companyprofile.inviteTeamMember": "Convidar Membro da Equipe",
  "companyprofile.invitationSent": "Convite Enviado com Sucesso",
  "virtualoffices.newOffice": "Novo Escritório",
  "virtualoffices.createOffice": "Criar Escritório Virtual",
  "virtualoffices.reviewChecklist": "Revisar Lista de Verificação de Documentos",
  "virtualoffices.setupDesc": "Configure um novo espaço de trabalho personalizado para seu negócio",
  "virtualoffices.customizeDesc": "Personalize os documentos que você precisa dos clientes",
  "virtualoffices.ph.officeName": "ex.: Garcia Seguros - Apólices Automotivas",
  "virtualoffices.ph.description": "Descreva o foco do seu escritório...",
  "virtualoffices.ph.addDocument": "Adicionar documento personalizado...",
  "virtualoffices.generating": "Gerando...",
  "virtualoffices.aiChecklist": "Lista de verificação gerada por IA para",
  "virtualoffices.clients": "Clientes",
  "virtualoffices.pending": "Pendente",
  "virtualoffices.invite": "Convidar",
  "virtualoffices.ind.manufacturing": "Manufatura",
  "virtualoffices.ind.insurance": "Seguros",
  "virtualoffices.ind.real_estate": "Imóveis",
  "virtualoffices.ind.automotive": "Automotivo",
  "virtualoffices.ind.import_export": "Importação/Exportação",
  "virtualoffices.ind.other": "Outro",
  "messages.conversations": "Conversas",
  "messages.searchPlaceholder": "Pesquisar mensagens...",
  "messages.noConversations": "Nenhuma conversa",
  "messages.send": "Enviar",
  "messages.selectConversation": "Selecionar uma Conversa",
  "messages.selectConversationDesc": "Escolha uma conversa na barra lateral para começar a conversar",
  "messages.support": "Suporte",
  "messages.client": "Cliente",
  "messages.deal": "Negócio",
  "meetings.subtitle": "Agendar e gerenciar reuniões por vídeo",
  "meetings.upcoming": "Próximas",
  "meetings.past": "Anteriores",
  "meetings.schedule": "Agendar",
  "meetings.startInstant": "Iniciar Instantânea",
  "meetings.startNow": "Iniciar Agora",
  "meetings.noPast": "Nenhuma reunião anterior",
  "meetings.noUpcoming": "Nenhuma reunião próxima",
  "meetings.createMeeting": "Criar Reunião",
  "meetings.startInstantMeeting": "Iniciar Reunião Instantânea",
  "meetings.scheduleMeeting": "Agendar Reunião",
  "meetings.scheduleDesc": "Agendar uma reunião por vídeo e enviar convites.",
  "meetings.invitePeople": "Convidar Pessoas (opcional)",
  "meetings.15min": "15 minutos",
  "meetings.30min": "30 minutos",
  "meetings.45min": "45 minutos",
  "meetings.allowRecording": "Permitir gravação",
  "meetings.recordingDesc": "Permite ao anfitrião gravar esta reunião",
  "meetings.waitingRoom": "Sala de Espera",
  "meetings.waitingRoomDesc": "Os participantes devem ser admitidos pelo anfitrião antes de participar",
  "meetings.emailPlaceholder": "email@exemplo.com",
  "meetings.cancelConfirm": "Cancelar esta reunião?",
  "meetings.cancelMeeting": "Cancelar reunião",
  "documents.title": "Documentos",
  "documents.viewAll": "Ver Todos",
  "documents.archived": "Arquivados",
  "documents.requestDocs": "Solicitar Documentos",
  "documents.upload": "Carregar",
  "documents.allDocuments": "Todos os Documentos",
  "documents.searchPlaceholder": "Pesquisar documentos...",
  "documents.addTag": "Adicionar etiqueta...",
  "documents.uploadDesc": "Arraste e solte arquivos ou clique para navegar. PDF, imagens, documentos Word suportados.",
  "documents.emailPlaceholder": "cliente@example.com",
  "documents.shareMsgPlaceholder": "Aqui está o documento que solicitou...",
  "documents.requestDesc": "Enviar um link de carregamento seguro para um cliente por email.",
  "documents.namePlaceholder": "João Silva",
  "documents.requestMsgPlaceholder": "Por favor, carregue os seguintes documentos...",
  "documents.folderName": "Nome da pasta",
  "documents.selectDestination": "Selecione uma pasta de destino.",
  "documents.statusUploaded": "Carregado",
  "documents.statusAnalyzed": "Analisado",
  "documents.statusArchived": "Arquivado",
  "documents.allTypes": "Todos os Tipos",
  "documents.inArchive": "no arquivo",
  "templates.allTemplates": "Todos os Modelos",
  "templates.editTemplate": "Editar Modelo",
  "templates.createCustomTemplate": "Criar Modelo Personalizado",
  "templates.editDesc": "Atualize seu modelo de documento",
  "templates.createDesc": "Crie seu próprio modelo de documento reutilizável",
  "templates.ph.templateName": "ex.: NDA Personalizado",
  "templates.ph.description": "Breve descrição do modelo",
  "templates.ph.content": "Digite o conteúdo do seu modelo aqui...",
  "templates.saving": "Salvando...",
  "templates.creating": "Criando...",
  "templates.saveChanges": "Salvar Alterações",
  "templates.createTemplate": "Criar Modelo",
  "templates.searchPlaceholder": "Pesquisar modelos...",
  "templates.popularTemplates": "Modelos Populares",
  "templates.defaultTemplates": "Modelos Padrão",
  "templates.deleteTemplate": "Excluir Modelo",
  "templates.preview": "Visualizar",
  "templates.description": "Descrição",
  "products.searchPlaceholder": "Pesquisar produtos...",
  "products.ph.service": "Serviços de Consultoria",
  "products.ph.product": "Widget Pro 3000",
  "products.selectCategory": "Selecionar categoria",
  "products.ph.describe": "Descreva o seu produto ou serviço...",
  "products.noMatches": "Não foram encontradas correspondências",
  "products.noProducts": "Ainda não há produtos ou serviços",
  "products.serviceDetails": "Detalhes do serviço",
  "products.productDetails": "Detalhes do produto",
  "products.inactive": "Inativo",
  "products.deleteConfirm": "Eliminar este item?",
  "products.saveChanges": "Guardar Alterações",
  "products.addItem": "Adicionar Item",
  "products.priceOnRequest": "Preço sob consulta",
  "products.perUnit": "Por Unidade",
  "tasks.searchPlaceholder": "Pesquisar tarefas...",
  "tasks.ph.title": "ex. Rever documentos legais",
  "tasks.ph.description": "Adicionar mais contexto a esta tarefa...",
  "tasks.selectDeal": "Selecionar um negócio para anexar",
  "tasks.noTasks": "Não há tarefas nesta coluna",
  "tasks.deleteTask": "Eliminar Tarefa",
  "settings.tabs.branding": "Marca",
  "settings.tabs.payments": "Pagamentos",
  "settings.tabs.plan": "Plano",
  "settings.tabs.integrations": "Integrações",
  "settings.appearance": "Aparência",
  "settings.saveBranding": "Guardar Marca",
  "settings.yourPlan": "O Seu Plano",
  "settings.ph.logoUrl": "https://example.com/logo.png",
  "settings.ph.customDomain": "deals.yourcompany.com",
  "settings.calendarFeedGenerated": "URL do feed do calendário gerado!",
  "settings.plan.free": "Gratuito",
  "settings.plan.pro": "Pro",
  "settings.plan.smallBusiness": "Pequenas Empresas",
  "settings.plan.businessPro": "Business Pro",
  "settings.plan.scale": "Scale",
  "settings.plan.enterprise": "Enterprise",
  "dealroom.meetings": "Reuniões",
  "dealroom.startMeeting": "Iniciar Reunião",
  "dealroom.noMeetings": "Nenhuma reunião vinculada a este negócio ainda",
  "dealroom.noMeetingsDesc": "Inicie uma reunião ou agende uma para começar",
  "dealroom.failedCreateMeeting": "Falha ao criar reunião",
  "dealroom.finalizedContract": "Contrato Finalizado — Pronto para Assinatura",
  "dealroom.previewNotSupported": "Visualização não suportada",
  "dealroom.aiMayTakeMoment": "Isto pode demorar um momento.",
  "dealroom.aiAnalysisGenerated": "A análise de IA foi gerada para os seguintes documentos:",
  "dealroom.docsUnanalyzed": "Os seguintes documentos permanecem não analisados:",
  "dealroom.analyzingDocs": "Analisando documentos...",
  "dealroom.finalizeWarning": "Esta ação não pode ser desfeita. O status do negócio mudará para Assinatura Pendente e todas as partes poderão assinar o contrato.",
  "dealroom.cannotRevert": "Não é possível reverter de Assinatura Pendente",
  "compliance.ph.productDesc": "ex.: Parafusos de aço inoxidável, M10 x 50mm...",
  "compliance.ph.exportDesc": "Descreva o produto ou tecnologia sendo exportada...",
  "compliance.select": "Selecionar...",
  "compliance.selectCountry": "Selecionar país...",
  "events.tradeShow": "Feira Comercial",
  "events.webinar": "Webinar",
  "events.networking": "Networking",
  "events.conference": "Conferência",
  "events.workshop": "Workshop",
  "events.ph.title": "Título do evento",
  "events.ph.location": "Endereço do local ou URL da reunião",
  "events.ph.maxAttendees": "Deixe vazio para ilimitado",
  "events.searchPlaceholder": "Pesquisar eventos...",
  "events.cancelRsvp": "Cancelar RSVP",
  "events.rsvp": "RSVP",
  "rfq.expired": "Expirado",
  "rfq.createRfq": "Criar Solicitação de Cotação",
  "rfq.visibility": "Visibilidade",
  "rfq.public": "Público - Todos os fornecedores podem ver",
  "rfq.private": "Privado - Somente por convite",
  "rfq.quantity": "Quantidade",
  "rfq.unit": "Unidade",
  "rfq.pieces": "Peças",
  "rfq.kilograms": "Quilogramas",
  "rfq.meters": "Metros",
  "rfq.squareMeters": "Metros Quadrados",
  "rfq.units": "Unidades",
  "rfq.sets": "Conjuntos",
  "rfq.boxes": "Caixas",
  "rfq.deliveryLocation": "Local de Entrega",
  "rfq.deliveryDeadline": "Prazo de Entrega",
  "rfq.specialRequirements": "Requisitos Especiais",
  "rfq.title": "Solicitações de Cotação",
  "rfq.subtitle": "Navegue pelas solicitações de fornecimento ou publique a sua",
  "rfq.rfqsPosted": "RFQs Publicados",
  "rfq.openRfqs": "RFQs Abertos",
  "rfq.quotesSent": "Cotações Enviadas",
  "rfq.winRate": "Taxa de Conversão",
  "rfq.allCategories": "Todas as Categorias",
  "rfq.noRfqsFound": "Nenhum RFQ encontrado",
  "rfq.noRfqsYet": "Nenhum RFQ ainda",
  "meetings.biweekly": "A cada 2 semanas",
  "meetings.cancelSeries": "Cancelar série inteira",
  "meetings.cancelThisMeeting": "Cancelar esta reunião",
  "meetings.nextInSeries": "Próximo na série",
  "nav.contractTemplates": "Contratos",
  "contracts.title": "Modelos de Contratos",
  "contracts.subtitle": "Geração de documentos legais com IA. Selecione um modelo para começar.",
  "documents.create": "Criar",
  "createDoc.untitledDocument": "Documento sem título",
  "createDoc.save": "Salvar",
  "createDoc.export": "Exportar",
  "createDoc.aiAssist": "Assistente IA",
  "createDoc.generate": "Gerar",
  "createDoc.generating": "Gerando...",
  "createDoc.cancel": "Cancelar",
  "createDoc.translate": "Traduzir",
  "createDoc.translateTitle": "Traduzir Documento",
  "createDoc.translateTo": "Traduzir para",
  "createDoc.translateNow": "Traduzir",
  "createDoc.translating": "Traduzindo...",
  "createDoc.translated": "Documento traduzido com sucesso",
  "createDoc.translateFailed": "Falha na tradução",
  "verification.status": "Status de Verificação",
  "verification.inProgress": "Verificação em Andamento",
  "verification.getVerified": "Verificar-se",
  "verification.cancelRequest": "Cancelar Solicitação",
  "verification.submit": "Enviar para Verificação",
  "verification.submitting": "Enviando...",
  "verification.uploadDocs": "Enviar Documentos",
  "verification.level": "Nível de Verificação",
  "verification.selectDocType": "Selecione o tipo de documento...",
  "contracts.generate": "Gerar",
  "contracts.backToTemplates": "Voltar aos modelos",
  "contracts.required": "Obrigatório",
  "contracts.modify": "Modificar",
  "contracts.finalize": "Finalizar",
  "contracts.applyChanges": "Aplicar Alterações",
  "contracts.confirmDelete": "Excluir este rascunho?",
  "contracts.generating": "Gerando documento...",
  "contracts.nda": "Acordo de Confidencialidade Mútuo",
  "contracts.sow": "Escopo de Trabalho",
  "contracts.msa": "Contrato Mestre de Serviços",
  "contracts.contractor": "Contrato de Prestador Independente",
  "contracts.loi": "Carta de Intenção",
  "templates.deleting": "Excluindo...",
  "templates.noDescription": "Sem descrição.",
  "templates.use": "Usar",
  "templates.confirmDeleteDesc": "Isso excluirá permanentemente este modelo. Esta ação não pode ser desfeita.",
  "templates.lib.ndaMutual": "NDA Mútuo",
  "templates.lib.purchaseAgreement": "Contrato de Compra",
  "templates.lib.serviceAgreement": "Contrato de Serviços",
  "templates.lib.priceQuote": "Cotação",
  "templates.lib.invoice": "Fatura",
  "templates.lib.loi": "Carta de Intenção",
  "settings.security": "Segurança",
  "security.twoFactor": "Autenticação de Dois Fatores",
  "security.enabled": "Ativado",
  "security.disabled": "Desativado",
  "security.enable2FA": "Ativar 2FA",
  "security.disable": "Desativar",
  "security.activeSessions": "Sessões Ativas",
  "security.logoutAll": "Sair de todos",
  "security.lastUsed": "Último uso",
  "security.currentSession": "Atual",
  "security.loginHistory": "Histórico de Login",
  "security.successfulLogin": "Login bem-sucedido",
  "security.failedLogin": "Tentativa falha",
  "security.verify": "Verificar",
  "security.cancel": "Cancelar",
  "security.password": "Senha",
  "security.done": "Concluído",
  "feedback.button": "Feedback",
  "feedback.title": "Enviar Feedback",
  "feedback.typeBug": "Bug",
  "feedback.typeFeature": "Recurso",
  "feedback.typeGeneral": "Geral",
  "feedback.descPlaceholder": "Conte-nos o que aconteceu...",
  "feedback.submit": "Enviar",
  "feedback.thanks": "Obrigado! Vamos analisar isso.",
};

export default pt;
